import { gql } from '@apollo/client';

export const GET_USER_ASSOCIATED_LINES_QUERY = gql`
  query GetUserAssociatedLinesQuery($agentID: ID!, $limit: Int = 50, $token: String = "1") {
    getAgentV2(agentID: $agentID) {
      ID
      associatedLines(limit: $limit, token: $token) {
        items {
          ID
          countryISOCode
          name
          phoneNumber
        }
        pageInfo {
          currentToken
          nextToken
          total
        }
      }
    }
  }
`;
